@if (loading.active())  {
<!--<div
  class="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm"
  role="status"
  aria-live="polite"
  aria-busy="true">
  &lt;!&ndash; 3 bouncing dots &ndash;&gt;
  <div class="flex items-end gap-2">
    <svg
      [attr.width]="svgSize()"
      [attr.height]="svgSize()"
      [attr.viewBox]="'0 0 ' + svgSize() + ' ' + svgSize()"
      class="animate-[ss-rotate_1.4s_linear_infinite]">
      <circle
        [attr.cx]="svgSize()/2"
        [attr.cy]="svgSize()/2"
        [attr.r]="svgSize()/2 - 4"
        fill="none"
        stroke="#e8f7ee"
        stroke-width="6" />
      <circle
        [attr.cx]="svgSize()/2"
        [attr.cy]="svgSize()/2"
        [attr.r]="svgSize()/2 - 4"
        fill="none"
        stroke="#489361"
        stroke-width="5"
        stroke-linecap="round"
        stroke-dasharray="150"
        stroke-dashoffset="150"
        [attr.transform]="'rotate(-90 ' + svgSize()/2 + ' ' + svgSize()/2 + ')'"
        class="animate-[ss-dash_1.4s_ease-in-out_infinite]" />
    </svg>
  </div>-->
  <div  class="anim-wrap fixed inset-0 z-9999 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm">
    <div class="ring-outer"></div>
    <div class="ring-inner"></div>
    <div class="logo-circle" id="logoCircle">
      <svg width="130" height="130" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
        <!-- Wool body clouds -->
        <g class="sheep-body">
          <ellipse cx="64" cy="72" rx="28" ry="20" fill="#F5F0E8"/>
          <circle cx="48" cy="59" r="15" fill="#F5F0E8"/>
          <circle cx="64" cy="54" r="17" fill="#F5F0E8"/>
          <circle cx="80" cy="59" r="15" fill="#F5F0E8"/>
          <!-- Wool texture highlights -->
          <circle cx="52" cy="55" r="6" fill="white" opacity="0.35"/>
          <circle cx="67" cy="51" r="7" fill="white" opacity="0.28"/>
          <circle cx="79" cy="56" r="5" fill="white" opacity="0.3"/>
          <circle cx="58" cy="68" r="5" fill="white" opacity="0.25"/>
        </g>
        <!-- Legs -->
        <g>
          <rect class="leg-fl" x="44" y="88" width="9" height="18" rx="4" fill="#D4C8A8"/>
          <rect class="leg-fr" x="57" y="88" width="9" height="18" rx="4" fill="#D4C8A8"/>
          <rect class="leg-rl" x="70" y="88" width="9" height="18" rx="4" fill="#D4C8A8"/>
          <rect class="leg-rr" x="83" y="88" width="9" height="18" rx="4" fill="#D4C8A8"/>
        </g>
        <!-- Head -->
        <g class="sheep-head">
          <ellipse cx="95" cy="63" rx="14" ry="13" fill="#E8DFC8"/>
          <!-- Ear -->
          <ellipse class="sheep-ear" cx="88" cy="51" rx="5" ry="7.5" fill="#D4C8A8" transform="rotate(-18 88 51)"/>
          <!-- Eye -->
          <g class="sheep-eye">
            <circle cx="99" cy="60" r="3.5" fill="#3D2B1A"/>
            <circle cx="100.5" cy="59" r="1.5" fill="white"/>
          </g>
          <!-- Nose -->
          <ellipse cx="106" cy="67" rx="4" ry="3" fill="#C4B898"/>
          <circle cx="105" cy="67" r="1" fill="#A89478" opacity="0.6"/>
          <circle cx="107.5" cy="67.5" r="0.8" fill="#A89478" opacity="0.6"/>
        </g>
        <!-- Gold RFID tag -->
<!--        <g class="gold-tag">
          <rect x="87" y="62" width="15" height="11" rx="2.5" fill="#C8943A"/>
          <circle cx="98.5" cy="67.5" r="2.5" fill="white" opacity="0.9"/>
          <line x1="87" y1="67.5" x2="82" y2="66" stroke="#C8943A" stroke-width="1.8" stroke-linecap="round"/>
          &lt;!&ndash; Signal waves from tag &ndash;&gt;
          <path d="M103 63 Q106 65.5 103 68" stroke="#FAC775" stroke-width="1.2" fill="none" opacity="0.7" stroke-linecap="round"/>
          <path d="M105 61 Q110 65.5 105 70" stroke="#FAC775" stroke-width="0.8" fill="none" opacity="0.4" stroke-linecap="round"/>
        </g>-->
        <!-- Ground shadow -->
        <ellipse cx="65" cy="108" rx="30" ry="5" fill="rgba(61,43,26,0.15)"/>
      </svg>
    </div>

  <!-- Sichtbarer Text -->
  <p class="mt-4 text-white font-medium">Daten werden geladen…</p>

  <!-- Screenreader Text -->
  <span class="sr-only">Bitte warten, Inhalte werden geladen</span>
</div>
}
